import {css} from 'aphrodite';
import classNames from 'classnames';
import React, {useRef} from 'react';
import _ from 'underscore';

import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {sharedStyles} from 'processes/settings/fields/ProcessTaskSchemaFieldConstants';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';

interface CanOnlyBePartOfFlowchartFieldProps {
  executionType: ProcessExecutionType;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled: boolean;
}

export default function CanOnlyBePartOfFlowchartField(
  props: CanOnlyBePartOfFlowchartFieldProps
): JSX.Element {
  const wrapperIdRef = useRef(_.uniqueId('canOnlyBePartOfFlowchartWrapper'));
  const checkboxIdRef = useRef(_.uniqueId('canOnlyBePartOfFlowchartCheckbox'));

  return (
    <InputWrapper id={wrapperIdRef.current} label="Flowchart only" labelStyle={FieldLabel.STYLES.LABEL}>
      {props.executionType !== ProcessExecutionType.FLOWCHART ? (
        <div className={classNames(css(sharedStyles.checkboxWrapper), 'editableField')}>
          <CheckboxInput
            id={checkboxIdRef.current}
            className={css(sharedStyles.checkboxField)}
            label="Can only be used as part of a flowchart"
            checked={props.value}
            disabled={props.disabled}
            onChange={(e) => {
              props.onChange(e.target.checked);
            }}
          />
        </div>
      ) : (
        <span className={css(sharedStyles.messageText)}>
          This setting is only available if execution type is Entry or Direct.
        </span>
      )}
    </InputWrapper>
  );
}
